import { FeatureIslandContainer, FeatureIslandHeader, FeatureIslandMainWithBackGround } from "../_layouts";
import { useHandlePrint } from "./_hooks";
import { ColorSettingForOptionPms } from "./color-setting";
import { CreateOptionPmsContainer } from "./create-option-pms";
import { FilterByOptionForOptionPmsContainer } from "./filter-by-option";
import { GuestListTableForOptionPms } from "./guest-list-table";
import { HasTimeLimitForOptionPms } from "./has-time-limit";
import { PrintGuestListForOptionPms, PrintTimelineForOptionPms } from "./print";
import { SearchByDateFormForOptionPms } from "./search-by-date-form";

import type { OptionPmsColorListQueryData } from "./_repository/query/type/query-data";

type Props = {
	hotelID: string;

	optionPmsColorListQueryData: OptionPmsColorListQueryData;
};

export const OptionPmsPresenter = ({ hotelID, optionPmsColorListQueryData }: Props) => {
	const { idForPrintBlockEl } = useHandlePrint();

	return (
		<>
			<div className="print:hidden">
				<FeatureIslandContainer>
					<FeatureIslandHeader title="オプションの管理" />

					<div className="space-y-3">
						{/* tablet 以下は表示しない */}
						<div className="hidden tablet:block">
							<FeatureIslandMainWithBackGround>
								{/* 色の設定 */}
								<ColorSettingForOptionPms
									hotelID={hotelID}
									optionPmsColorListQueryData={optionPmsColorListQueryData}
								/>
							</FeatureIslandMainWithBackGround>
						</div>

						<FeatureIslandMainWithBackGround>
							<div className="space-y-4">
								{/* 日付での検索 */}
								<SearchByDateFormForOptionPms>
									{({ searchDate }) => (
										// 表示するオプションの絞り込み
										<FilterByOptionForOptionPmsContainer searchDate={searchDate} hotelID={hotelID}>
											{({ filteredOptionPmsActiveListQueryData }) => (
												<div className="space-y-12">
													{filteredOptionPmsActiveListQueryData.optionPmsList.options.length >
														0 && (
														// 時間指定のあるオプション
														<HasTimeLimitForOptionPms
															hotelID={hotelID}
															searchDate={searchDate}
															optionPmsActiveListQueryData={
																filteredOptionPmsActiveListQueryData
															}
															// print component
															printTimelineForOptionPmsChildren={
																<PrintTimelineForOptionPms
																	hotelID={hotelID}
																	searchDate={searchDate}
																	optionPmsActiveListQueryData={
																		filteredOptionPmsActiveListQueryData
																	}
																	optionPmsColorListQueryData={
																		optionPmsColorListQueryData
																	}
																/>
															}
															optionPmsColorListQueryData={optionPmsColorListQueryData}
														/>
													)}

													{/* 予約者リスト */}
													<GuestListTableForOptionPms
														hotelID={hotelID}
														searchDate={searchDate}
														optionPmsActiveListQueryData={
															filteredOptionPmsActiveListQueryData
														}
														// print component
														printGuestListForOptionPmsChildren={
															<PrintGuestListForOptionPms
																searchDate={searchDate}
																optionPmsActiveListQueryData={
																	filteredOptionPmsActiveListQueryData
																}
																optionPmsColorListQueryData={
																	optionPmsColorListQueryData
																}
															/>
														}
														optionPmsColorListQueryData={optionPmsColorListQueryData}
														// オプションの作成
														createOptionPmsDialogChildren={({
															hotelID,
															onCloseCallback,
														}) => (
															<CreateOptionPmsContainer
																key={searchDate}
																searchDate={searchDate}
																hotelID={hotelID}
																onCloseCallback={onCloseCallback}
															/>
														)}
													/>
												</div>
											)}
										</FilterByOptionForOptionPmsContainer>
									)}
								</SearchByDateFormForOptionPms>
							</div>
						</FeatureIslandMainWithBackGround>
					</div>
				</FeatureIslandContainer>
			</div>

			{/* 印刷用の element */}
			<div id={idForPrintBlockEl} className="hidden !bg-white print:block" />
		</>
	);
};
